import 'core-js/stable';

import 'bootstrap';
import { configuration } from 'config/constants';
import { configureI18n } from 'config/i18n';
import { configureRum } from 'config/rum';
import { AppProvider } from 'components/common/AppProvider';
import { ErrorBoundary } from 'components/common/ErrorBoundary';
import { MaterialUiProvider } from 'components/common/MaterialUiProvider';
import { ScrollToTop } from 'components/common/ScrollToTop';
import { SgwtWebAnalytics } from 'components/common/SgwtWebAnalytics';
import i18n from 'i18next';
import React, { FC } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { initSGConnect } from 'services/SgConnect';
import { messages, locales } from 'virtual-vite-i18n-resources';
import { AppRoutes } from 'routes';


import './css/bootstrapTheming.scss';
import './css/site.scss';

const App: FC<{ children: React.ReactNode, matomoSiteId?: string }> = ({ children, matomoSiteId }) => <AppProvider>
    <MaterialUiProvider>
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <SgwtWebAnalytics siteId={matomoSiteId} />
                {children}
            </BrowserRouter>
        </ErrorBoundary>
    </MaterialUiProvider>
</AppProvider>;

async function start() {
    const { matomoSiteId } = configuration;

    const renderApp = () => {
        const container = document.getElementById('root');
        const root = createRoot(container!);
        root.render(<App matomoSiteId={matomoSiteId}><AppRoutes /></App>);
        const appInitLoader = document.getElementById('app-init-loader');
        if (appInitLoader) {
            appInitLoader.remove();
        }
    };

    initSGConnect();

    await configureI18n(messages, locales);
    configureRum();

    if (import.meta?.hot) {
        import.meta.hot.on('locales-update', (data: Record<string, Record<string, object>>) => {
            Object.keys(data)
                .forEach((lang) => {
                    Object.keys(data[lang])
                        .forEach((ns) => {
                            i18n.addResourceBundle(lang, ns, data[lang][ns]);
                        });
                });
        });
    }

    renderApp();
}

start();
